var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontpageStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.381,
    height: 167,
    viewBox: "0 0 115.381 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(-1061 -1003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(27.22 456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(1033.78 614.113)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M41.883,261.6v6.729l-3.606-1.58-.233-.1-.754-.331a6.476,6.476,0,0,1,.031-2.717l.723-.317.177-.077Z",
    transform: "translate(-19.88 -231.014)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    d: "M97.113,213.452a6.433,6.433,0,0,1-.857,3.213,6.536,6.536,0,0,1-1.049,1.369,6.47,6.47,0,0,1-4.581,1.905H78.445a6.48,6.48,0,0,1-4.582-11.07,6.513,6.513,0,0,1,4.582-1.905H90.626A6.507,6.507,0,0,1,97.113,213.452Z",
    transform: "translate(-52.688 -179.505)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 30.495,
    cy: 30.495,
    rx: 30.495,
    ry: 30.495,
    transform: "translate(0)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(15.156 17.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(15.072 23.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M264.555,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M305.369,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-302.131 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M229.413,30.429,227.932,33.2l-.534,1-.9,1.7-.014.025a.783.783,0,0,1-.961.371.769.769,0,0,1-.48-.486l-2.023-5.893a3.487,3.487,0,0,1,.82-3.59,3.41,3.41,0,0,1,1.009-.709,3.367,3.367,0,0,1,1.581-.3l.107.007.067.006.066,0,.108.01A3.464,3.464,0,0,1,229.413,30.429Z",
    transform: "translate(-210.087 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M227.932,38.216l-.534,1-.9,1.7-.014.025a.783.783,0,0,1-.961.371.769.769,0,0,1-.48-.486l-2.023-5.893a3.487,3.487,0,0,1,.82-3.59,3.41,3.41,0,0,1,1.009-.709,4.235,4.235,0,0,1,2.275,3.051Z",
    transform: "translate(-210.087 -30.326)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M158.344,60.019,157.3,54.166a3.3,3.3,0,0,0-4.977-2.252l-.087.056-.053.036-.054.035-.085.058a3.3,3.3,0,0,0,.158,5.461l5,3.223A.752.752,0,0,0,158.344,60.019Z",
    transform: "translate(-142.062 -49.928)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M402.986,113.137a1.086,1.086,0,0,0-1.763.95.453.453,0,0,0-.048.015c-1.861.719-3.135,3.074-3.689,4.485a.452.452,0,1,0,.842.331c.488-1.241,1.618-3.371,3.173-3.971a.451.451,0,0,0,.152-.1,1.085,1.085,0,0,0,1.333-1.713Z",
    transform: "translate(-374.733 -107.889)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M6.847,261.6v6.729l-3.606-1.58-.233-.1-.754-.331-1.92-.841a.557.557,0,0,1,0-1.021l1.951-.855.723-.317.177-.077Z",
    transform: "translate(0 -248.088)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(4.114 10.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    d: "M97.113,213.452a6.433,6.433,0,0,1-.857,3.213,6.536,6.536,0,0,1-1.049,1.369,6.47,6.47,0,0,1-4.581,1.905H78.445a6.48,6.48,0,0,1-4.582-11.07,6.513,6.513,0,0,1,4.582-1.905H90.626A6.507,6.507,0,0,1,97.113,213.452Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M124.977,213.453a6.433,6.433,0,0,1-.857,3.213,6.445,6.445,0,0,1-3.941,1.344H108a6.506,6.506,0,0,1-6.488-6.488,6.43,6.43,0,0,1,.858-3.214,6.444,6.444,0,0,1,3.94-1.343h12.181A6.507,6.507,0,0,1,124.977,213.453Z",
    transform: "translate(-95.707 -196.58)",
    fill: "#ffdf9c"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 0.84,
    cy: 0.84,
    rx: 0.84,
    ry: 0.84,
    transform: "translate(39.309 31.064)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(26.783 27.459)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 2.847,
    height: 12.975,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 2.846,
    height: 12.975,
    transform: "translate(7.283)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(26.783 38.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M206.23,399.592v1.929h-2.847v-1.965a6.048,6.048,0,0,0,.664.036Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 2.846,
    height: 1.931,
    transform: "translate(7.283 0.034)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M223.751,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-221.733 -428.135)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M346.184,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-337.167 -428.135)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 30.495,
    cy: 30.495,
    rx: 30.495,
    ry: 30.495,
    transform: "translate(1049.735 568.424)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M385.41,391.834c-.353,0-.709-.006-1.058-.016l.008-.254c.5.016,1.014.02,1.518.013l0,.254Q385.646,391.834,385.41,391.834Zm2-.059-.015-.254c.5-.03,1.012-.071,1.513-.124l.027.253C388.43,391.7,387.917,391.745,387.41,391.775Zm-4.586-.04c-.507-.039-1.019-.09-1.522-.152l.031-.252c.5.061,1.008.112,1.511.15Zm7.629-.279-.038-.251c.5-.076,1-.164,1.5-.262l.049.249c-.5.1-1,.187-1.507.264Zm-10.665-.093c-.5-.085-1.006-.182-1.5-.29l.054-.248c.492.107.994.2,1.491.288Zm13.665-.5-.061-.247c.49-.121.983-.255,1.465-.4l.072.244C394.443,390.6,393.947,390.738,393.453,390.86Zm-16.655-.146c-.491-.131-.985-.274-1.469-.427l.077-.242c.48.152.971.294,1.458.424Zm19.587-.724-.083-.24c.476-.165.954-.344,1.422-.532l.094.236c-.472.189-.954.369-1.433.535Zm-22.508-.2c-.477-.175-.957-.365-1.427-.562l.1-.234c.466.2.942.384,1.416.558Zm25.346-.936-.105-.231c.457-.208.916-.429,1.365-.659l.116.226c-.452.231-.915.454-1.375.664Zm-28.171-.253c-.459-.219-.919-.451-1.368-.691l.12-.224c.446.238.9.469,1.357.686Zm30.89-1.136-.126-.221c.438-.25.876-.513,1.3-.781l.136.215c-.428.271-.868.535-1.31.787Zm-33.592-.307c-.436-.259-.873-.533-1.3-.813l.14-.212c.422.278.855.549,1.288.807Zm36.174-1.326-.145-.208c.413-.288.824-.59,1.224-.9l.155.2C405.355,385.236,404.94,385.541,404.524,385.831Zm-38.732-.358c-.41-.3-.82-.61-1.218-.928l.159-.2c.395.315.8.625,1.209.921Zm41.155-1.505-.164-.194c.385-.324.767-.663,1.138-1.005l.172.187c-.373.345-.759.686-1.146,1.013Zm-43.547-.4c-.382-.335-.761-.682-1.128-1.034l.176-.183c.364.349.74.695,1.119,1.027Zm45.793-1.672-.181-.178c.354-.359.705-.731,1.042-1.1l.189.17c-.34.377-.693.751-1.05,1.113Zm-48-.446c-.35-.369-.7-.749-1.029-1.132l.192-.167c.33.38.673.758,1.021,1.123Zm50.048-1.827-.2-.161c.32-.39.636-.792.937-1.2l.2.152C411.882,378.82,411.564,379.225,411.242,379.618Zm-52.053-.482c-.315-.4-.625-.808-.921-1.22l.206-.148c.294.409.6.816.914,1.211Zm53.887-1.969-.21-.143c.283-.417.561-.847.825-1.277l.217.133c-.266.433-.546.866-.831,1.286Zm-55.672-.512c-.277-.424-.548-.861-.806-1.3l.219-.129c.256.434.525.867.8,1.289Zm57.275-2.1-.222-.123c.244-.441.481-.895.7-1.348l.228.113c-.225.456-.464.913-.71,1.358Zm-58.826-.534c-.237-.448-.467-.908-.683-1.366l.23-.108c.215.455.443.911.678,1.355Zm60.183-2.213-.233-.1c.2-.462.4-.936.578-1.408l.237.091C416.435,370.866,416.239,371.343,416.035,371.809Zm-61.485-.548c-.195-.468-.381-.946-.554-1.422l.239-.087c.172.472.357.947.55,1.411Zm62.584-2.315-.241-.08c.159-.478.308-.966.445-1.452l.245.069C417.444,367.973,417.294,368.465,417.134,368.946Zm-63.628-.557c-.151-.484-.293-.979-.422-1.471l.246-.065c.128.488.269.979.419,1.459ZM417.962,366l-.248-.058c.114-.49.218-.99.309-1.486l.25.046c-.092.5-.2,1-.312,1.5Zm-65.232-.571c-.106-.5-.2-1-.285-1.5l.251-.042c.083.5.178,1,.283,1.492Zm65.786-2.437-.252-.034c.068-.5.126-1.005.172-1.509l.253.023c-.046.507-.1,1.019-.173,1.52Zm-66.287-.58c-.06-.5-.109-1.015-.146-1.523l.254-.019c.037.5.086,1.012.145,1.511Zm66.563-2.466-.254-.011c.023-.5.034-1.014.034-1.518h.254c0,.507-.012,1.022-.035,1.529Zm-66.787-.585c-.009-.312-.013-.629-.013-.945q0-.293.005-.586l.254,0q-.005.29-.005.581c0,.313,0,.628.013.938Zm66.565-1.3c-.005-.5-.022-1.014-.05-1.518l.254-.014c.028.507.045,1.022.05,1.529Zm-66.259-1.744-.254-.016c.032-.508.076-1.021.13-1.524l.253.027C352.387,355.306,352.343,355.815,352.312,356.319Zm66.09-1.288c-.051-.5-.114-1.008-.188-1.507l.251-.037c.074.5.138,1.013.189,1.518Zm-65.763-1.73-.251-.039c.078-.5.168-1.009.269-1.506l.249.05C352.806,352.3,352.716,352.8,352.639,353.3Zm65.319-1.273c-.1-.5-.206-.995-.325-1.483l.247-.06c.12.492.23.995.328,1.494Zm-64.717-1.7-.246-.062c.123-.492.26-.988.406-1.475l.243.073C353.5,349.344,353.363,349.837,353.241,350.325Zm64-1.247c-.142-.484-.3-.971-.46-1.447l.24-.083c.165.48.321.97.464,1.458Zm-63.124-1.665-.24-.084c.169-.48.351-.963.542-1.435l.236.1C354.464,346.458,354.283,346.937,354.116,347.414Zm62.137-1.206c-.185-.468-.384-.937-.59-1.4l.232-.1c.208.462.408.935.595,1.406Zm-61-1.614-.231-.106c.212-.462.438-.926.671-1.378l.226.117C355.691,343.675,355.467,344.135,355.256,344.594Zm59.753-1.148c-.227-.449-.468-.9-.716-1.336l.221-.125c.25.441.492.894.722,1.346Zm-58.358-1.554-.22-.127c.253-.44.521-.881.795-1.31l.214.137C357.168,341.018,356.9,341.455,356.651,341.892Zm56.865-1.084c-.269-.427-.55-.853-.836-1.266l.209-.145c.288.416.572.845.842,1.275Zm-55.23-1.477-.208-.146c.293-.415.6-.83.911-1.231l.2.156C358.881,338.507,358.577,338.918,358.287,339.33Zm53.5-1.016c-.306-.4-.625-.8-.948-1.185l.195-.163c.325.388.647.79.955,1.194Zm-51.639-1.385-.193-.165c.329-.386.671-.771,1.018-1.142l.186.173C360.815,336.165,360.475,336.547,360.148,336.93Zm49.69-.941c-.341-.372-.7-.74-1.052-1.094l.179-.18c.36.357.716.728,1.06,1.1ZM362.22,334.71l-.178-.182c.363-.355.739-.707,1.118-1.045l.169.19C362.954,334.008,362.581,334.357,362.22,334.71Zm45.465-.861c-.374-.339-.76-.674-1.148-.995l.162-.2c.39.323.78.66,1.157,1Zm-43.2-1.16-.16-.2c.393-.32.8-.636,1.207-.938l.151.2C365.277,332.057,364.874,332.37,364.484,332.688Zm40.861-.776c-.4-.3-.819-.6-1.234-.886l.143-.21c.419.286.837.587,1.244.893Zm-38.423-1.03-.142-.211c.421-.283.854-.56,1.287-.824l.132.217C367.769,330.326,367.339,330.6,366.921,330.882Zm35.915-.685c-.429-.266-.87-.525-1.311-.77l.124-.222c.444.247.888.508,1.321.776Zm-33.324-.891-.122-.223c.445-.243.9-.48,1.356-.7l.112.228c-.451.221-.9.455-1.346.7Zm30.669-.589c-.452-.225-.915-.443-1.377-.647l.1-.232c.465.205.932.425,1.387.652Zm-27.947-.743-.1-.233c.465-.2.941-.395,1.414-.575l.09.238c-.47.178-.942.37-1.4.57Zm25.165-.487c-.471-.182-.952-.357-1.431-.517l.081-.241c.483.162.968.338,1.442.521Zm-22.33-.589-.079-.241c.483-.158.976-.307,1.464-.443l.068.245c-.485.135-.974.283-1.453.44Zm19.448-.378c-.485-.138-.979-.267-1.469-.382l.058-.247c.494.116.992.246,1.481.385Zm-16.523-.434-.057-.248c.5-.113,1-.216,1.5-.306l.045.25c-.5.089-1,.192-1.488.3Zm13.569-.263c-.495-.093-1-.176-1.5-.246l.035-.252c.5.071,1.011.154,1.51.247Zm-10.581-.277-.034-.252c.5-.067,1.015-.124,1.521-.168l.022.253c-.5.044-1.01.1-1.509.166Zm7.575-.146c-.5-.047-1.01-.083-1.514-.108l.012-.254c.508.025,1.021.061,1.526.109Zm-4.551-.118-.011-.254c.467-.02.943-.029,1.415-.03h.115v.254h-.114c-.468,0-.941.01-1.4.029Z",
    transform: "translate(699.156 240.136)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(1079.963 608.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-2",
    "data-name": "Path 358",
    d: "M264.555,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-2",
    "data-name": "Path 359",
    d: "M305.369,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-302.131 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M229.413,30.429,227.932,33.2l-.534,1-.9,1.7-.014.025a.783.783,0,0,1-.961.371.769.769,0,0,1-.48-.486l-2.023-5.893a3.487,3.487,0,0,1,.82-3.59,3.41,3.41,0,0,1,1.009-.709,3.367,3.367,0,0,1,1.581-.3l.107.007.067.006.066,0,.108.01A3.464,3.464,0,0,1,229.413,30.429Z",
    transform: "translate(854.804 560.183)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M227.932,38.216l-.534,1-.9,1.7-.014.025a.783.783,0,0,1-.961.371.769.769,0,0,1-.48-.486l-2.023-5.893a3.487,3.487,0,0,1,.82-3.59,3.41,3.41,0,0,1,1.009-.709,4.235,4.235,0,0,1,2.275,3.051Z",
    transform: "translate(854.804 555.172)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M158.344,60.019,157.3,54.166a3.3,3.3,0,0,0-4.977-2.252l-.087.056-.053.036-.054.035-.085.058a3.3,3.3,0,0,0,.158,5.461l5,3.223A.752.752,0,0,0,158.344,60.019Z",
    transform: "translate(922.828 535.57)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M402.986,113.137a1.086,1.086,0,0,0-1.763.95.453.453,0,0,0-.048.015c-1.861.719-3.135,3.074-3.689,4.485a.452.452,0,1,0,.842.331c.488-1.241,1.618-3.371,3.173-3.971a.451.451,0,0,0,.152-.1,1.085,1.085,0,0,0,1.333-1.713Z",
    transform: "translate(690.157 477.608)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M6.847,261.6v6.729l-3.606-1.58-.233-.1-.754-.331-1.92-.841a.557.557,0,0,1,0-1.021l1.951-.855.723-.317.177-.077Z",
    transform: "translate(1064.891 337.409)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M41.883,261.6v6.729l-3.606-1.58-.233-.1-.754-.331a6.476,6.476,0,0,1,.031-2.717l.723-.317.177-.077Z",
    transform: "translate(1029.855 337.409)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-2",
    "data-name": "SVGCleanerId_0",
    d: "M97.113,213.452a6.433,6.433,0,0,1-.857,3.213,6.536,6.536,0,0,1-1.049,1.369,6.47,6.47,0,0,1-4.581,1.905H78.445a6.48,6.48,0,0,1-4.582-11.07,6.513,6.513,0,0,1,4.582-1.905H90.626A6.507,6.507,0,0,1,97.113,213.452Z",
    transform: "translate(997.047 388.918)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(1069.004 595.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_2",
    "data-name": "SVGCleanerId_0_1_",
    d: "M97.113,213.452a6.433,6.433,0,0,1-.857,3.213,6.536,6.536,0,0,1-1.049,1.369,6.47,6.47,0,0,1-4.581,1.905H78.445a6.48,6.48,0,0,1-4.582-11.07,6.513,6.513,0,0,1,4.582-1.905H90.626A6.507,6.507,0,0,1,97.113,213.452Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M124.977,213.453a6.433,6.433,0,0,1-.857,3.213,6.445,6.445,0,0,1-3.941,1.344H108a6.506,6.506,0,0,1-6.488-6.488,6.43,6.43,0,0,1,.858-3.214,6.444,6.444,0,0,1,3.94-1.343h12.181A6.507,6.507,0,0,1,124.977,213.453Z",
    transform: "translate(969.183 388.917)",
    fill: "#ffdf9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 0.84,
    cy: 0.84,
    rx: 0.84,
    ry: 0.84,
    transform: "translate(1089.044 599.487)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(1076.517 595.882)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-2",
    "data-name": "Rectangle 16",
    width: 2.847,
    height: 12.975,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-2",
    "data-name": "Rectangle 17",
    width: 2.846,
    height: 12.975,
    transform: "translate(7.283)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(1088.172 602.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(30.228 40.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-3",
    "data-name": "Path 358",
    d: "M264.555,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-3",
    "data-name": "Path 359",
    d: "M305.369,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-302.131 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(0 0)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 30.495,
    cy: 30.495,
    rx: 30.495,
    ry: 30.495,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M229.413,30.429,227.932,33.2l-.534,1-.9,1.7-.014.025a.783.783,0,0,1-.961.371.769.769,0,0,1-.48-.486l-2.023-5.893a3.487,3.487,0,0,1,.82-3.59,3.41,3.41,0,0,1,1.009-.709,3.367,3.367,0,0,1,1.581-.3l.107.007.067.006.066,0,.108.01A3.464,3.464,0,0,1,229.413,30.429Z",
    transform: "translate(-194.931 -8.241)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M227.932,38.216l-.534,1-.9,1.7-.014.025a.783.783,0,0,1-.961.371.769.769,0,0,1-.48-.486l-2.023-5.893a3.487,3.487,0,0,1,.82-3.59,3.41,3.41,0,0,1,1.009-.709,4.235,4.235,0,0,1,2.275,3.051Z",
    transform: "translate(-194.931 -13.252)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M158.344,60.019,157.3,54.166a3.3,3.3,0,0,0-4.977-2.252l-.087.056-.053.036-.054.035-.085.058a3.3,3.3,0,0,0,.158,5.461l5,3.223A.752.752,0,0,0,158.344,60.019Z",
    transform: "translate(-126.906 -32.854)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M402.986,113.137a1.086,1.086,0,0,0-1.763.95.453.453,0,0,0-.048.015c-1.861.719-3.135,3.074-3.689,4.485a.452.452,0,1,0,.842.331c.488-1.241,1.618-3.371,3.173-3.971a.451.451,0,0,0,.152-.1,1.085,1.085,0,0,0,1.333-1.713Z",
    transform: "translate(-359.577 -90.815)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M6.847,261.6v6.729l-3.606-1.58-.233-.1-.754-.331-1.92-.841a.557.557,0,0,1,0-1.021l1.951-.855.723-.317.177-.077Z",
    transform: "translate(15.156 -231.014)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M41.883,261.6v6.729l-3.606-1.58-.233-.1-.754-.331a6.476,6.476,0,0,1,.031-2.717l.723-.317.177-.077Z",
    transform: "translate(-19.88 -231.014)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-3",
    "data-name": "SVGCleanerId_0",
    d: "M97.113,213.452a6.433,6.433,0,0,1-.857,3.213,6.536,6.536,0,0,1-1.049,1.369,6.47,6.47,0,0,1-4.581,1.905H78.445a6.48,6.48,0,0,1-4.582-11.07,6.513,6.513,0,0,1,4.582-1.905H90.626A6.507,6.507,0,0,1,97.113,213.452Z",
    transform: "translate(-52.688 -179.505)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(19.269 27.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_3",
    "data-name": "SVGCleanerId_0_1_",
    d: "M97.113,213.452a6.433,6.433,0,0,1-.857,3.213,6.536,6.536,0,0,1-1.049,1.369,6.47,6.47,0,0,1-4.581,1.905H78.445a6.48,6.48,0,0,1-4.582-11.07,6.513,6.513,0,0,1,4.582-1.905H90.626A6.507,6.507,0,0,1,97.113,213.452Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M124.977,213.453a6.433,6.433,0,0,1-.857,3.213,6.445,6.445,0,0,1-3.941,1.344H108a6.506,6.506,0,0,1-6.488-6.488,6.43,6.43,0,0,1,.858-3.214,6.444,6.444,0,0,1,3.94-1.343h12.181A6.507,6.507,0,0,1,124.977,213.453Z",
    transform: "translate(-80.551 -179.506)",
    fill: "#ffdf9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 0.84,
    cy: 0.84,
    rx: 0.84,
    ry: 0.84,
    transform: "translate(39.309 31.064)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(26.783 27.459)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-3",
    "data-name": "Rectangle 16",
    width: 2.847,
    height: 12.975,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-3",
    "data-name": "Rectangle 17",
    width: 2.846,
    height: 12.975,
    transform: "translate(7.283)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(26.783 38.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-2",
    "data-name": "Path 367",
    d: "M206.23,399.592v1.929h-2.847v-1.965a6.048,6.048,0,0,0,.664.036Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-2",
    "data-name": "Rectangle 18",
    width: 2.846,
    height: 1.931,
    transform: "translate(7.283 0.034)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-2",
    "data-name": "Path 368",
    d: "M223.751,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-221.733 -428.135)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-2",
    "data-name": "Path 369",
    d: "M346.184,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-337.167 -428.135)",
    fill: "#3f3d56"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(1076.517 606.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-3",
    "data-name": "Path 367",
    d: "M206.23,399.592v1.929h-2.847v-1.965a6.048,6.048,0,0,0,.664.036Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-3",
    "data-name": "Rectangle 18",
    width: 2.846,
    height: 1.931,
    transform: "translate(7.283 0.034)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-3",
    "data-name": "Path 368",
    d: "M223.751,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-221.733 -428.135)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-3",
    "data-name": "Path 369",
    d: "M346.184,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-337.167 -428.135)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(1068.554 638.735)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 30.495,
    cy: 30.495,
    rx: 30.495,
    ry: 30.495,
    transform: "translate(0.762 5.464)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M6.847,261.6v6.729l-3.606-1.58-.233-.1-.754-.331-1.92-.841a.557.557,0,0,1,0-1.021l1.951-.855.723-.317.177-.077Z",
    transform: "translate(15.918 -225.551)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M385.41,391.834c-.353,0-.709-.006-1.058-.016l.008-.254c.5.016,1.014.02,1.518.013l0,.254Q385.646,391.834,385.41,391.834Zm2-.059-.015-.254c.5-.03,1.012-.071,1.513-.124l.027.253C388.43,391.7,387.917,391.745,387.41,391.775Zm-4.586-.04c-.507-.039-1.019-.09-1.522-.152l.031-.252c.5.061,1.008.112,1.511.15Zm7.629-.279-.038-.251c.5-.076,1-.164,1.5-.262l.049.249c-.5.1-1,.187-1.507.264Zm-10.665-.093c-.5-.085-1.006-.182-1.5-.29l.054-.248c.492.107.994.2,1.491.288Zm13.665-.5-.061-.247c.49-.121.983-.255,1.465-.4l.072.244C394.443,390.6,393.947,390.738,393.453,390.86Zm-16.655-.146c-.491-.131-.985-.274-1.469-.427l.077-.242c.48.152.971.294,1.458.424Zm19.587-.724-.083-.24c.476-.165.954-.344,1.422-.532l.094.236c-.472.189-.954.369-1.433.535Zm-22.508-.2c-.477-.175-.957-.365-1.427-.562l.1-.234c.466.2.942.384,1.416.558Zm25.346-.936-.105-.231c.457-.208.916-.429,1.365-.659l.116.226c-.452.231-.915.454-1.375.664Zm-28.171-.253c-.459-.219-.919-.451-1.368-.691l.12-.224c.446.238.9.469,1.357.686Zm30.89-1.136-.126-.221c.438-.25.876-.513,1.3-.781l.136.215c-.428.271-.868.535-1.31.787Zm-33.592-.307c-.436-.259-.873-.533-1.3-.813l.14-.212c.422.278.855.549,1.288.807Zm36.174-1.326-.145-.208c.413-.288.824-.59,1.224-.9l.155.2C405.355,385.236,404.94,385.541,404.524,385.831Zm-38.732-.358c-.41-.3-.82-.61-1.218-.928l.159-.2c.395.315.8.625,1.209.921Zm41.155-1.505-.164-.194c.385-.324.767-.663,1.138-1.005l.172.187c-.373.345-.759.686-1.146,1.013Zm-43.547-.4c-.382-.335-.761-.682-1.128-1.034l.176-.183c.364.349.74.695,1.119,1.027Zm45.793-1.672-.181-.178c.354-.359.705-.731,1.042-1.1l.189.17c-.34.377-.693.751-1.05,1.113Zm-48-.446c-.35-.369-.7-.749-1.029-1.132l.192-.167c.33.38.673.758,1.021,1.123Zm50.048-1.827-.2-.161c.32-.39.636-.792.937-1.2l.2.152C411.882,378.82,411.564,379.225,411.242,379.618Zm-52.053-.482c-.315-.4-.625-.808-.921-1.22l.206-.148c.294.409.6.816.914,1.211Zm53.887-1.969-.21-.143c.283-.417.561-.847.825-1.277l.217.133c-.266.433-.546.866-.831,1.286Zm-55.672-.512c-.277-.424-.548-.861-.806-1.3l.219-.129c.256.434.525.867.8,1.289Zm57.275-2.1-.222-.123c.244-.441.481-.895.7-1.348l.228.113c-.225.456-.464.913-.71,1.358Zm-58.826-.534c-.237-.448-.467-.908-.683-1.366l.23-.108c.215.455.443.911.678,1.355Zm60.183-2.213-.233-.1c.2-.462.4-.936.578-1.408l.237.091C416.435,370.866,416.239,371.343,416.035,371.809Zm-61.485-.548c-.195-.468-.381-.946-.554-1.422l.239-.087c.172.472.357.947.55,1.411Zm62.584-2.315-.241-.08c.159-.478.308-.966.445-1.452l.245.069C417.444,367.973,417.294,368.465,417.134,368.946Zm-63.628-.557c-.151-.484-.293-.979-.422-1.471l.246-.065c.128.488.269.979.419,1.459ZM417.962,366l-.248-.058c.114-.49.218-.99.309-1.486l.25.046c-.092.5-.2,1-.312,1.5Zm-65.232-.571c-.106-.5-.2-1-.285-1.5l.251-.042c.083.5.178,1,.283,1.492Zm65.786-2.437-.252-.034c.068-.5.126-1.005.172-1.509l.253.023c-.046.507-.1,1.019-.173,1.52Zm-66.287-.58c-.06-.5-.109-1.015-.146-1.523l.254-.019c.037.5.086,1.012.145,1.511Zm66.563-2.466-.254-.011c.023-.5.034-1.014.034-1.518h.254c0,.507-.012,1.022-.035,1.529Zm-66.787-.585c-.009-.312-.013-.629-.013-.945q0-.293.005-.586l.254,0q-.005.29-.005.581c0,.313,0,.628.013.938Zm66.565-1.3c-.005-.5-.022-1.014-.05-1.518l.254-.014c.028.507.045,1.022.05,1.529Zm-66.259-1.744-.254-.016c.032-.508.076-1.021.13-1.524l.253.027C352.387,355.306,352.343,355.815,352.312,356.319Zm66.09-1.288c-.051-.5-.114-1.008-.188-1.507l.251-.037c.074.5.138,1.013.189,1.518Zm-65.763-1.73-.251-.039c.078-.5.168-1.009.269-1.506l.249.05C352.806,352.3,352.716,352.8,352.639,353.3Zm65.319-1.273c-.1-.5-.206-.995-.325-1.483l.247-.06c.12.492.23.995.328,1.494Zm-64.717-1.7-.246-.062c.123-.492.26-.988.406-1.475l.243.073C353.5,349.344,353.363,349.837,353.241,350.325Zm64-1.247c-.142-.484-.3-.971-.46-1.447l.24-.083c.165.48.321.97.464,1.458Zm-63.124-1.665-.24-.084c.169-.48.351-.963.542-1.435l.236.1C354.464,346.458,354.283,346.937,354.116,347.414Zm62.137-1.206c-.185-.468-.384-.937-.59-1.4l.232-.1c.208.462.408.935.595,1.406Zm-61-1.614-.231-.106c.212-.462.438-.926.671-1.378l.226.117C355.691,343.675,355.467,344.135,355.256,344.594Zm59.753-1.148c-.227-.449-.468-.9-.716-1.336l.221-.125c.25.441.492.894.722,1.346Zm-58.358-1.554-.22-.127c.253-.44.521-.881.795-1.31l.214.137C357.168,341.018,356.9,341.455,356.651,341.892Zm56.865-1.084c-.269-.427-.55-.853-.836-1.266l.209-.145c.288.416.572.845.842,1.275Zm-55.23-1.477-.208-.146c.293-.415.6-.83.911-1.231l.2.156C358.881,338.507,358.577,338.918,358.287,339.33Zm53.5-1.016c-.306-.4-.625-.8-.948-1.185l.195-.163c.325.388.647.79.955,1.194Zm-51.639-1.385-.193-.165c.329-.386.671-.771,1.018-1.142l.186.173C360.815,336.165,360.475,336.547,360.148,336.93Zm49.69-.941c-.341-.372-.7-.74-1.052-1.094l.179-.18c.36.357.716.728,1.06,1.1ZM362.22,334.71l-.178-.182c.363-.355.739-.707,1.118-1.045l.169.19C362.954,334.008,362.581,334.357,362.22,334.71Zm45.465-.861c-.374-.339-.76-.674-1.148-.995l.162-.2c.39.323.78.66,1.157,1Zm-43.2-1.16-.16-.2c.393-.32.8-.636,1.207-.938l.151.2C365.277,332.057,364.874,332.37,364.484,332.688Zm40.861-.776c-.4-.3-.819-.6-1.234-.886l.143-.21c.419.286.837.587,1.244.893Zm-38.423-1.03-.142-.211c.421-.283.854-.56,1.287-.824l.132.217C367.769,330.326,367.339,330.6,366.921,330.882Zm35.915-.685c-.429-.266-.87-.525-1.311-.77l.124-.222c.444.247.888.508,1.321.776Zm-33.324-.891-.122-.223c.445-.243.9-.48,1.356-.7l.112.228c-.451.221-.9.455-1.346.7Zm30.669-.589c-.452-.225-.915-.443-1.377-.647l.1-.232c.465.205.932.425,1.387.652Zm-27.947-.743-.1-.233c.465-.2.941-.395,1.414-.575l.09.238c-.47.178-.942.37-1.4.57Zm25.165-.487c-.471-.182-.952-.357-1.431-.517l.081-.241c.483.162.968.338,1.442.521Zm-22.33-.589-.079-.241c.483-.158.976-.307,1.464-.443l.068.245c-.485.135-.974.283-1.453.44Zm19.448-.378c-.485-.138-.979-.267-1.469-.382l.058-.247c.494.116.992.246,1.481.385Zm-16.523-.434-.057-.248c.5-.113,1-.216,1.5-.306l.045.25c-.5.089-1,.192-1.488.3Zm13.569-.263c-.495-.093-1-.176-1.5-.246l.035-.252c.5.071,1.011.154,1.51.247Zm-10.581-.277-.034-.252c.5-.067,1.015-.124,1.521-.168l.022.253c-.5.044-1.01.1-1.509.166Zm7.575-.146c-.5-.047-1.01-.083-1.514-.108l.012-.254c.508.025,1.021.061,1.526.109Zm-4.551-.118-.011-.254c.467-.02.943-.029,1.415-.03h.115v.254h-.114c-.468,0-.941.01-1.4.029Z",
    transform: "translate(-351.993 -325)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(30.99 45.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-4",
    "data-name": "Path 358",
    d: "M264.555,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-4",
    "data-name": "Path 359",
    d: "M305.369,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-302.131 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M229.413,30.429,227.932,33.2l-.534,1-.9,1.7-.014.025a.783.783,0,0,1-.961.371.769.769,0,0,1-.48-.486l-2.023-5.893a3.487,3.487,0,0,1,.82-3.59,3.41,3.41,0,0,1,1.009-.709,3.367,3.367,0,0,1,1.581-.3l.107.007.067.006.066,0,.108.01A3.464,3.464,0,0,1,229.413,30.429Z",
    transform: "translate(-194.169 -2.777)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M227.932,38.216l-.534,1-.9,1.7-.014.025a.783.783,0,0,1-.961.371.769.769,0,0,1-.48-.486l-2.023-5.893a3.487,3.487,0,0,1,.82-3.59,3.41,3.41,0,0,1,1.009-.709,4.235,4.235,0,0,1,2.275,3.051Z",
    transform: "translate(-194.169 -7.788)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M158.344,60.019,157.3,54.166a3.3,3.3,0,0,0-4.977-2.252l-.087.056-.053.036-.054.035-.085.058a3.3,3.3,0,0,0,.158,5.461l5,3.223A.752.752,0,0,0,158.344,60.019Z",
    transform: "translate(-126.144 -27.39)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M402.986,113.137a1.086,1.086,0,0,0-1.763.95.453.453,0,0,0-.048.015c-1.861.719-3.135,3.074-3.689,4.485a.452.452,0,1,0,.842.331c.488-1.241,1.618-3.371,3.173-3.971a.451.451,0,0,0,.152-.1,1.085,1.085,0,0,0,1.333-1.713Z",
    transform: "translate(-358.815 -85.351)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M41.883,261.6v6.729l-3.606-1.58-.233-.1-.754-.331a6.476,6.476,0,0,1,.031-2.717l.723-.317.177-.077Z",
    transform: "translate(-19.118 -225.551)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-4",
    "data-name": "SVGCleanerId_0",
    d: "M97.113,213.452a6.433,6.433,0,0,1-.857,3.213,6.536,6.536,0,0,1-1.049,1.369,6.47,6.47,0,0,1-4.581,1.905H78.445a6.48,6.48,0,0,1-4.582-11.07,6.513,6.513,0,0,1,4.582-1.905H90.626A6.507,6.507,0,0,1,97.113,213.452Z",
    transform: "translate(-51.925 -174.042)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(20.032 32.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_4",
    "data-name": "SVGCleanerId_0_1_",
    d: "M97.113,213.452a6.433,6.433,0,0,1-.857,3.213,6.536,6.536,0,0,1-1.049,1.369,6.47,6.47,0,0,1-4.581,1.905H78.445a6.48,6.48,0,0,1-4.582-11.07,6.513,6.513,0,0,1,4.582-1.905H90.626A6.507,6.507,0,0,1,97.113,213.452Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M124.977,213.453a6.433,6.433,0,0,1-.857,3.213,6.445,6.445,0,0,1-3.941,1.344H108a6.506,6.506,0,0,1-6.488-6.488,6.43,6.43,0,0,1,.858-3.214,6.444,6.444,0,0,1,3.94-1.343h12.181A6.507,6.507,0,0,1,124.977,213.453Z",
    transform: "translate(-79.789 -174.043)",
    fill: "#ffdf9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 0.84,
    cy: 0.84,
    rx: 0.84,
    ry: 0.84,
    transform: "translate(40.071 36.527)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(27.545 32.922)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-4",
    "data-name": "Rectangle 16",
    width: 2.847,
    height: 12.975,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-4",
    "data-name": "Rectangle 17",
    width: 2.846,
    height: 12.975,
    transform: "translate(7.283)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(27.545 43.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-4",
    "data-name": "Path 367",
    d: "M206.23,399.592v1.929h-2.847v-1.965a6.048,6.048,0,0,0,.664.036Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-4",
    "data-name": "Rectangle 18",
    width: 2.846,
    height: 1.931,
    transform: "translate(7.283 0.034)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-4",
    "data-name": "Path 368",
    d: "M223.751,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-221.733 -428.135)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-4",
    "data-name": "Path 369",
    d: "M346.184,429.868v2.8a.453.453,0,0,1-.905,0v-2.8Z",
    transform: "translate(-337.167 -428.135)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    transform: "translate(1113 702)",
    fill: "#00a050",
    fontSize: 40,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+"))), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "+",
    transform: "translate(1054 590)",
    fill: "#00a050",
    fontSize: 40,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontpageStep3);
export default __webpack_public_path__ + "static/media/frontpage_step_3.4c398894386ec5f2c2769a5b558805ef.svg";
export { ForwardRef as ReactComponent };